<mat-accordion class="participant position-relative">
	<mat-expansion-panel hideToggle [class]="{ canceled: isCanceled }">
		<mat-expansion-panel-header class="h-auto">
			<mat-panel-title>
				@if (slot) {
					<div class="d-flex flex-column justify-content-between align-content-center w-100">
						<div class="d-flex justify-content-between flex-row align-items-center mb-3 mt-2">
							<span>
								{{ slot.status }} |
								<span class="fw-bold">
									@if (auth.permissionsByCode()[Permissions.ADMIN]) {
										{{ slot.id }}
									}
									{{ commonService.getUserName(slot.userData) }}
								</span>
								@if (isChild) {
									<small> (dziecko)</small>
								}
								@if ((slot.userData?.userDocuments?.length ?? 0) > 0) {
									<i class="fa-solid fa-file-circle-check px-1"></i>
								}
							</span>

							<div class="fs-7 text-end">
								@if (slot.userData?.birth) {
									<span> u: {{ slot.userData.birth }} </span>
								}
								@if (slot.userData?.userContacts[0] && slot.userData?.userContacts[0].phone) {
									<span>
										tel:
										{{ slot.userData.userContacts[0].phone }}
									</span>
								}
							</div>
						</div>
						<div class="fs-7">
							@if (slot.stopDeparture; as stop) {
								<span>
									W ({{ stop.stop?.location?.name }}): {{ stop.stop?.address }} ({{
										stop.fee | price
									}}
									PLN)
									{{ commonService.getDate(stop.timeDeparture) }}
									({{ commonService.getWeekday(stop.timeDeparture) }})
									{{ commonService.getTime(stop.timeDeparture) }}
								</span>
							} @else {
								W ({{ offer.wasTransportAvailable ? OWN_TRANSPORT_NAME : NO_TRANSPORT_NAME }})
							}
						</div>
						<div class="fs-7 pb-2">
							@if (slot.stopReturn; as stop) {
								<span>
									P ({{ stop.stop?.location?.name }}):
									{{ stop.stop?.address }}
									({{ stop.fee | price }} PLN)
									{{ commonService.getDate(stop.timeDeparture) }}
									({{ commonService.getWeekday(stop.timeDeparture) }})
									{{ commonService.getTime(stop.timeDeparture) }}
								</span>
							} @else {
								P ({{ offer.wasTransportAvailable ? OWN_TRANSPORT_NAME : NO_TRANSPORT_NAME }})
							}
						</div>

						<div class="d-flex justify-content-end gap-1 pb-2 fs-7">
							@if (slot.preCancellationPriceSummary) {
								<span class="rounded-0 bg-black bg-opacity-10 px-2 py-1">
									Cena przed anulacją:
									<span class="fw-bold text-decoration-line-through"
										>{{ slot.preCancellationPriceSummary.price | price }} PLN</span
									>
								</span>

								<span class="rounded-0 bg-black bg-opacity-10 px-2 py-1 me-2">
									<span class="fw-bold">{{
										slot.preCancellationPriceSummary.paidRatio | percent: '1.0-0'
									}}</span>
									wartości
								</span>
							}
							<span class="fw-bold d-flex justify-content-center align-items-center"
								>{{ slot.totalPrice | price }} PLN</span
							>
						</div>
					</div>
				}
				@if (!isCanceled) {
					<button
						(click)="$event.stopPropagation()"
						mat-icon-button
						class="position-absolute top-0 end-0 fs-5 mt-2 participantMenuButton"
						[matMenuTriggerFor]="menu"
					>
						<i class="fas fa-ellipsis-vertical"></i>
					</button>
					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="showParticipantEditDialog(slot)">
							<span>Zmień Dane Uczestnika</span>
						</button>
						<button mat-menu-item (click)="showChangeParticipantDialog()">
							<span>Zmień Uczestnika</span>
						</button>
						<button mat-menu-item (click)="enableSlotDragging()">
							<span>Zmień Pokój dla uczestnika</span>
						</button>
						<button
							mat-menu-item
							class="cancelParticipantButton"
							(click)="showCancelDialog()"
							[disabled]="
								isCanceled || reservationService.isReservationCancelled || isLastParticipantInOffer
							"
						>
							<span>Anuluj Uczestnika</span>
						</button>
					</mat-menu>
				}
			</mat-panel-title>
		</mat-expansion-panel-header>
		@if (slot?.transportDeparture || slot?.transportReturn || slot?.catalogPrice || slot?.slotServices.length) {
			<mat-card
				appearance="outlined"
				class="position-relative d-flex flex-column gap-2"
				[class]="{ canceled: isCanceled }"
			>
				@if (!isCanceled) {
					@if (slot.catalogPrice) {
						<div class="row">
							<div class="col">Cena katalogowa</div>
							<div class="col text-end">
								{{
									slot.catalogPrice - slot.priceTransportDeparture - slot.priceTransportReturn | price
								}}
								PLN
							</div>
						</div>
					}
					@if (offer && offer.board) {
						<div class="row">
							<div class="col">Wyżywienie ({{ offer.board.name }})</div>
							<div class="col text-end">{{ slot.priceBoard | price }} PLN</div>
						</div>
					}
					@if (slot.promotionValue && offer) {
						<div class="row">
							<div class="col">Promocja ({{ offer.promotion[0]?.catalog.name }})</div>
							<div class="col text-end">{{ slot.promotionValue * -1 | price }} PLN</div>
						</div>
					}
					@if (offer.insurance) {
						<div class="row">
							<div class="col">{{ offer.insurance.name }}</div>
							<div class="col text-end">{{ offer.insurance.price * slot.days | price }} PLN</div>
						</div>
					}
					@if (slot.stopDeparture) {
						<div class="row">
							<div class="col">Wyjazd: {{ slot.stopDeparture.stop?.location?.name }}</div>
							<div class="col text-end">{{ slot.priceTransportDeparture | price }} PLN</div>
						</div>
					}
					@if (slot.stopReturn) {
						<div class="row">
							<div class="col">Powrót: {{ slot.stopReturn.stop?.location?.name }}</div>
							<div class="col text-end">{{ slot.priceTransportReturn | price }} PLN</div>
						</div>
					}
					@for (service of slot?.slotServices; track service.service.id) {
						<div class="row">
							<div class="col">{{ service.service.name }}</div>
							<div class="col text-end">{{ service.price | price }} PLN</div>
						</div>
					}
					@if (slot.priceAdjustment) {
						<div class="row">
							<div class="col">Wyrównanie ceny</div>
							<div class="col text-end">{{ slot.priceAdjustment | price }} PLN</div>
						</div>
					}
				} @else {
					@if (!!cancellationInsurance) {
						<div class="row">
							<div class="col-8">
								{{ cancellationInsurance.service.name }}
								@if (cancellationInsurance.service.serviceType.name === CANCELLATION_INSURANCE_NAME) {
									<button
										(click)="resetCancellationInsurancePrice(cancellationInsurance.id)"
										class="ms-2"
										mat-flat-button
										color="accent"
									>
										Wyzeruj
									</button>
								}
							</div>
							<div class="col-4 text-end">{{ cancellationInsurance.price | price }} PLN</div>
						</div>
					}
					<div class="row">
						<div class="col">Koszt anulacji</div>
						<div class="col text-end">{{ slot.feeDueToCancellation | price }} PLN</div>
					</div>
				}
			</mat-card>
		}
	</mat-expansion-panel>
</mat-accordion>
